import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';

export class ChangeCurrentClientDialogInput {
    client: Client;
    nurSchweinebetriebe = false;
    nurRinderbetriebe = false;
}
